import CheckroomIcon from '@mui/icons-material/Checkroom';

import { basicRoles } from '@/router/consts';
import { productMap } from '@/router/productMap';

import type { SidebarMenu } from '../../types';

// 사장님
const productMenus: SidebarMenu[] = [
  {
    title: productMap['origin-list'].title,
    path: productMap['origin-list'].path,
    icon: <CheckroomIcon />,
    roles: basicRoles,
  },
];

export default productMenus;
